import PercentDisplay from './PercentDisplay'

export default PercentDisplay
